import {EN} from './en';
import {ES} from './es';

export const DEFAULT_LOCALE = 'en';

export const DEFAULT_NS = 'translation';

export const LOCALES = {
  en: {
    [DEFAULT_NS]: EN,
  },
  es: {
    [DEFAULT_NS]: ES,
  },
};

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: typeof DEFAULT_NS;

    resources: {
      [DEFAULT_NS]: typeof EN;
    };
  }
}
